import { Component } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-no-compliance-tile',
  templateUrl: './no-compliance-tile.component.html',
  styleUrls: ['./compliance-tile.component.scss'],
})
export class NoComplianceTileComponent {
}